import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ParseHTML from "../../global/components/ParseHTML";

const NO_ACCESS_TEXT: string = process.env.REACT_APP_DIRECTORY_NO_ACCESS_TEXT!;
const MCC_BOILERPLATE = process.env.REACT_APP_MCC_INFO!;
export default function NoAccess() {
    return (
        <Box padding={2}>
            <Typography variant="h6" color="secondary.dark" paragraph={true}>{ParseHTML(NO_ACCESS_TEXT)}</Typography>
            <Typography variant="h6" color="secondary.dark" paragraph={true}>{ParseHTML(MCC_BOILERPLATE)}</Typography>
        </Box>
    );
}